import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-telegram',
  templateUrl: './icon-telegram.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTelegramComponent {}
